// @flow

import { PREBOOKING_FORM } from 'Client/cms/toolkit/constants';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import {
  CUSTOMER_BOOKING_PREBOOKING_FORM_FETCH_DATA,
  CUSTOMER_BOOKING_PREBOOKING_FORM_FETCH_RESORTS,
} from 'Utils/request/requestDictionary';
import { type PrebookingFormLineProps } from 'Components/lines/prebooking-form-line/PrebookingFormLine.utils';

function getPrebookingQuery(
  resortIds: Array<string>,
  appContext: AppContext,
  props: PrebookingFormLineProps,
) {
  const productIdsAsString = JSON.stringify(resortIds);
  const message = props.stay.minAgeInformation;

  const { cmsContent, cmsRelease, country } = appContext;
  return `{
    config {
      memberSpace {
        accessButtonLoggedin
      }
    }
    success: pageByPageId(pageId: "prebooking-form-success") { url }
    error: pageByPageId(pageId: "prebooking-form-error") { url }
    civilities {
      adult {
        name: label
        value: code
      }
    }
    travelAgencies(countryCode: "${country}" agencyTypes: [CLUBMED, FRANCHISE]) {
      id
      name
      address {
        city
      }
    }
    bookingsCriteria(resortIds: ${productIdsAsString}) {
      durations
      departureCities {
        value
        name
      }
    }
    resorts(resortIds: ${productIdsAsString}) {
      id
      name
      destination {
        country
      }
      accommodations {
        id
        label
        categories {
          id
          label
        }
      }
      openingDates {
        opening
        closing
      }
      adultOnly
      minAuthorizedAge {
        formattedValue(message: "${message}" content: "${cmsContent}" release: "${cmsRelease}")
        value
      }
    }
    accommodationCategories(productIds: ${productIdsAsString}) {
      productId
      accommodations {
        id
        label
        ranking
      }
    }
    legalInformations {
      newsletterOptins {
        id
        title
        description
      }
    }
  }`;
}

export const prebookingFormResolver = {
  name: PREBOOKING_FORM,
  resolve: async (appContext: AppContext, props: PrebookingFormLineProps) => {
    const resortsQuery = `{
      resorts {
        id
      }
    }`;
    const { products } = props;
    const { resorts } = await graphQLClient.runQuery(resortsQuery, appContext, {
      requestName: CUSTOMER_BOOKING_PREBOOKING_FORM_FETCH_RESORTS,
      strictErrors: false,
    });

    const productIds = products.map(({ productId }) => productId);
    const prebookingProductIds = resorts
      .filter(({ id }) => productIds.includes(id))
      .map(({ id }) => id);
    const prebookingQuery = getPrebookingQuery(prebookingProductIds, appContext, props);
    return graphQLClient.runQuery(prebookingQuery, appContext, {
      requestName: CUSTOMER_BOOKING_PREBOOKING_FORM_FETCH_DATA,
      strictErrors: false,
    });
  },
};
